import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getCategoryMedia } from "@/lib/mediaQuery";
import { useSeo } from "@/hooks/useSeo";
import MediaBrowser from "@/components/feature/MediaBrowser";

export default function CategoryPage() {
  const { type = "" } = useParams();
  const category = categories.find((c) => c.slug === type);

  const items = useMemo(() => getCategoryMedia(type), [type]);

  useSeo({
    title: category ? `${category.name}分类 - 缘之空影视资讯平台` : "分类未找到 - 缘之空影视资讯平台",
    description: category
      ? `${category.description} 缘之空${category.name}分类页面提供多维筛选与排序，助你快速找到感兴趣的影视作品。`
      : "该分类暂不可用，请返回缘之空首页浏览其他影视分类。",
    keywords: category ? `缘之空,${category.name},影视资讯,${category.name}推荐,剧情介绍` : "缘之空,影视分类",
  });

  if (!category) {
    return (
      <div className="w-full px-4 md:px-6 py-20 flex flex-col items-center text-center">
        <span className="w-16 h-16 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center mb-4">
          <i className="ri-error-warning-line text-3xl"></i>
        </span>
        <h1 className="font-heading text-xl font-bold text-foreground-950 mb-2">该分类暂不可用</h1>
        <p className="text-sm text-foreground-500 mb-6">你访问的分类不存在或已调整，可以返回首页浏览其他影视内容。</p>
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </div>
    );
  }

  return (
    <div className="w-full px-4 md:px-6 py-8 md:py-10">
      <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-5 flex-wrap">
        <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
        <i className="ri-arrow-right-s-line text-foreground-300"></i>
        <span className="text-foreground-800">{category.name}</span>
      </nav>

      <div className="mb-7">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3 flex items-center gap-3">
          <i className={`${category.icon} text-primary-500`}></i>
          {category.name}分类
        </h1>
        <p className="text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">{category.description}</p>
      </div>

      <div className="flex flex-wrap gap-2 mb-6">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className={`px-4 py-2 rounded-md text-sm transition-colors whitespace-nowrap ${
              c.slug === type
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
            }`}
          >
            {c.name}
          </Link>
        ))}
      </div>

      <MediaBrowser items={items} />
    </div>
  );
}